import React from 'react';

export default ({ size = 25 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 26 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_32536_229"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="1"
      y="0"
      width={size}
      height={size}
    >
      <path
        d="M1.65881 13.8244L3.31764 5.25381L3.87058 0.277344H20.7353L24.3294 6.63617L21.8412 12.995L25.1588 17.142L20.7353 23.7773L14.6529 19.0773L6.63528 18.5244L1.65881 13.8244Z"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_32536_229)" />
    <path
      d="M5.2891 11.4694C5.53378 12.4288 6.53696 13.519 7.3926 13.9962C8.49151 14.6092 9.66669 14.7084 10.8824 14.3949C11.9327 14.1176 12.9204 13.2841 13.5073 12.3837C13.7383 12.0294 13.8894 11.6339 13.9996 11.244C14.0664 11.0076 14.0849 10.5408 14.3308 10.5209C14.5988 10.4994 15.9674 10.4522 16.1474 10.5182C16.2212 10.6386 16.094 11.3071 16.056 11.4638C15.896 12.1314 15.6311 12.7693 15.2713 13.3539C15.1682 13.5183 14.9966 13.7054 14.9077 13.8665C14.7143 14.1239 13.7472 15.2204 13.4745 15.2758C12.9983 15.5656 12.6773 15.8373 12.1367 16.0699C9.3008 17.2896 5.88202 16.3222 4.16358 13.7373C4.00333 13.4963 3.83195 13.2633 3.71399 13.0001C4.14524 12.633 4.88784 11.7453 5.2891 11.4694Z"
      fill="#FDBC04"
    />
    <path
      d="M3.71406 13.0002C3.64142 12.8299 3.56264 12.6665 3.49193 12.4943C2.83646 10.8977 2.89353 8.93098 3.5638 7.34724C4.19409 5.85789 5.52909 4.5193 7.03645 3.91582C8.47647 3.34032 10.0668 3.25938 11.5578 3.68564C11.9216 3.79305 12.2171 3.92763 12.5651 4.07636C12.1878 4.4226 11.3302 5.40321 10.9489 5.63983C8.12426 4.76934 5.2202 6.84913 5.10478 9.74951C5.0784 10.4122 5.13768 10.8312 5.28917 11.4696C4.8879 11.7454 4.14531 12.6331 3.71406 13.0002Z"
      fill="#EB4338"
    />
    <path
      d="M17.6913 1.88477C17.7625 1.97233 17.9287 2.93544 18.0237 3.21604C18.1862 3.70136 18.4176 4.16089 18.7106 4.58055C19.545 5.77728 20.9021 6.71025 22.3698 6.89144C22.5309 6.91133 22.7015 6.94571 22.8621 6.97393C22.7567 7.0042 22.6697 7.01603 22.5622 7.02473C20.4868 7.19264 18.6445 8.8247 18.009 10.7738C17.87 11.2001 17.8494 11.6375 17.7316 12.062C17.7057 12.0009 17.6493 11.5144 17.6301 11.4049C17.2831 9.42455 15.6595 7.69251 13.7219 7.16016C13.5016 7.10097 13.2773 7.05787 13.0508 7.03126C12.9266 7.0171 12.8222 7.0296 12.7013 6.99817C12.73 6.95611 12.9194 6.9349 12.9761 6.92834C15.3911 6.64945 17.6485 4.35769 17.6913 1.88477Z"
      fill="#4385F5"
    />
    <path
      d="M14.9077 13.8652C15.3722 14.2942 15.8532 14.7941 16.3047 15.2443L18.9265 17.8649L20.4172 19.3566C20.5789 19.5185 21.1556 20.068 21.2394 20.2224C21.192 20.4112 20.0854 21.4685 19.8838 21.6533C19.5512 21.383 19.1159 20.92 18.8058 20.6066C18.2673 20.0607 17.7257 19.5178 17.1811 18.9781L14.7358 16.532C14.3512 16.1484 13.8218 15.6654 13.4745 15.2745C13.7472 15.2191 14.7142 14.1225 14.9077 13.8652Z"
      fill="#34A953"
    />
    <path
      d="M11.294 20.8516C11.3249 20.9229 11.3389 21.8404 11.3271 21.9671L11.288 21.9493C11.2049 21.8011 11.2631 21.0354 11.294 20.8516Z"
      fill="#D8D7DA"
      fillOpacity="0.756863"
    />
    <path
      d="M9.79476 20.7559C9.85796 20.8718 9.82954 21.5293 9.81999 21.7071L9.78832 21.7091C9.74166 21.6191 9.76176 20.8819 9.79476 20.7559Z"
      fill="#D8D7DA"
      fillOpacity="0.611765"
    />
    <path
      d="M9.53591 20.8555C9.61788 20.951 9.56385 21.6066 9.5528 21.75C9.46038 21.6758 9.50652 20.995 9.53591 20.8555Z"
      fill="#010302"
      fillOpacity="0.886275"
    />
    <path
      d="M14.1648 20.6777C14.3043 20.7399 14.4888 21.2478 14.4701 21.3958C14.3816 21.3482 14.2289 20.8284 14.1648 20.6777Z"
      fill="#D8D7DA"
      fillOpacity="0.537255"
    />
    <path
      d="M8.92369 21.1094C8.99318 21.1815 9.04757 21.6579 9.07429 21.8194L9.00872 21.7804C8.90437 21.5948 8.92276 21.3277 8.92369 21.1094Z"
      fill="#D8D7DA"
      fillOpacity="0.0862745"
    />
    <path
      d="M11.6287 20.8433C11.6755 20.5028 12.1349 20.5885 12.1104 20.8265C12.0025 20.7957 12.0351 20.6618 11.8376 20.6554C11.6836 20.7429 11.6856 20.9709 11.6877 21.1232C11.6793 21.0224 11.6799 20.9308 11.6287 20.8433Z"
      fill="#D8D7DA"
      fillOpacity="0.203922"
    />
    <path
      d="M7.78085 21.4136C7.78838 21.2962 7.7334 20.8363 7.75749 20.7852C7.86165 20.9011 7.84036 21.4087 7.84151 21.6032C7.82269 21.5265 7.809 21.487 7.78085 21.4136Z"
      fill="#D8D7DA"
      fillOpacity="0.235294"
    />
    <path
      d="M13.7528 20.6602C13.7928 20.662 13.8395 20.6692 13.8799 20.6744C13.8793 20.6726 13.8562 21.0185 13.8651 21.111L13.8409 21.151L13.8093 21.1283C13.7711 21.0422 13.7636 20.7757 13.7528 20.6602Z"
      fill="#D8D7DA"
      fillOpacity="0.513725"
    />
    <path
      d="M11.6286 20.8418C11.6798 20.9293 11.6793 21.0209 11.6876 21.1217C11.6869 21.2416 11.6874 21.3616 11.6891 21.4815L11.622 21.5008C11.6482 21.2539 11.566 21.0642 11.6286 20.8418Z"
      fill="#D8D7DA"
      fillOpacity="0.407843"
    />
    <path
      d="M10.8196 20.8789L10.8473 20.9102C10.8897 21.147 10.8908 21.3162 10.8698 21.5564C10.8419 21.5508 10.852 21.5501 10.8251 21.5192C10.7995 21.3565 10.8014 21.0446 10.8196 20.8789Z"
      fill="#D8D7DA"
      fillOpacity="0.87451"
    />
    <path
      d="M11.6221 21.5017L11.6892 21.4824C11.689 21.5473 11.7369 21.9078 11.7383 21.9046L11.6833 21.9057C11.5947 21.8069 11.6126 21.6604 11.6205 21.5247L11.6221 21.5017Z"
      fill="#D8D7DA"
      fillOpacity="0.843137"
    />
    <path
      d="M13.2811 21.2868C13.2785 21.1784 13.2633 20.8177 13.3124 20.7285C13.3423 20.9447 13.3305 21.2091 13.3282 21.43L13.2811 21.2868Z"
      fill="#9DA4A4"
      fillOpacity="0.862745"
    />
    <path
      d="M12.8179 20.7305C13.0261 20.7777 12.9965 21.0584 12.9306 21.2089L12.8858 21.1735C12.9217 20.9666 12.9341 20.9101 12.8179 20.7305Z"
      fill="#D8D7DA"
      fillOpacity="0.25098"
    />
    <path
      d="M8.60177 21.375C8.69847 21.494 8.6195 21.6799 8.58127 21.8118L8.54639 21.7702C8.52482 21.6491 8.56865 21.4923 8.60177 21.375Z"
      fill="#D8D7DA"
      fillOpacity="0.737255"
    />
    <path
      d="M7.39243 20.7344C7.45383 20.8858 7.42196 21.0569 7.35651 21.2004C7.33655 21.0805 7.3165 20.8293 7.39243 20.7344Z"
      fill="#D8D7DA"
      fillOpacity="0.396078"
    />
    <path
      d="M12.2942 20.7559C12.3336 20.9759 12.332 21.0736 12.3329 21.2985L12.28 21.3932C12.2717 21.1668 12.2599 20.9807 12.2942 20.7559Z"
      fill="#010302"
      fillOpacity="0.490196"
    />
    <path
      d="M13.2811 21.2871L13.3282 21.4303C13.3318 21.5285 13.3476 21.7661 13.2969 21.8419C13.273 21.6918 13.2808 21.4466 13.2811 21.2871Z"
      fill="#D8D7DA"
      fillOpacity="0.498039"
    />
    <path
      d="M7.78089 21.4141C7.80904 21.4875 7.82273 21.527 7.84155 21.6036C7.82829 21.6682 7.82292 21.6816 7.79448 21.7412L7.77414 21.7418C7.75345 21.6386 7.77115 21.5203 7.78089 21.4141Z"
      fill="#D8D7DA"
      fillOpacity="0.505882"
    />
    <path
      d="M7.37595 21.498L7.409 21.539C7.43062 21.6378 7.41698 21.6762 7.39558 21.7761C7.32717 21.6761 7.35293 21.6088 7.37595 21.498Z"
      fill="#D8D7DA"
      fillOpacity="0.65098"
    />
    <path
      d="M11.0502 20.8516C11.1136 20.9045 11.0863 20.9801 11.083 21.059L11.051 21.0662C11.039 20.9945 11.0465 20.9245 11.0502 20.8516Z"
      fill="#010302"
      fillOpacity="0.0156863"
    />
    <path
      d="M12.3328 21.2969C12.3329 21.375 12.3411 21.4443 12.302 21.511C12.2824 21.4547 12.279 21.4501 12.2799 21.3916L12.3328 21.2969Z"
      fill="#010302"
      fillOpacity="0.286275"
    />
  </svg>
);
